import React from "react";

interface PropsI {
    children: React.ReactNode;
    className?: string;
}

const Card = ({ children, className }: PropsI) => {
    return (
        <div className={`card-component ${className}`}>
            {children}
        </div>
    )
}
export default Card;